import Schema from 'datagent/src/classes/Schema.class';


/**
 * 舆情数据维度
 *
 * @property {String[]} fields - 字段名称列表
 * @property {Object} fieldSet - 字段设定
 *
 * @class dimensionSchema
 */
export const DimensionSchema = new Schema({
  'dimensionId': {type: Number, default: ""},
  'dimension': {type: String, default: ""}, //维度名称
  'dimensionScore': {type: Number, default: 0}, //维度得分
  'dimensionWeight': {type: Number, default: ""}, //维度权重
  'dimensionRuleExplain': {type: String, default: ""}, //维度评分标准
})
export default DimensionSchema